const INITIAL_STATE_VARIABLE = "FIT_initialState"

import isBuilderContext from "@/lib/is-platform/is-builder-context"
import { LS_KEYS, get, set } from "@/lib/local-storage"
import fetchPageData from "@/lib/fetch-page-data"

export const cacheInDOM = (path, data) => {
  const script = document.createElement("script")

  script.innerHTML = `
        window.${INITIAL_STATE_VARIABLE} = window.${INITIAL_STATE_VARIABLE} || {};
        window.${INITIAL_STATE_VARIABLE}['${path}'] = ${JSON.stringify(data)};
      `

  document.head.appendChild(script)
}

export const cacheInLocalStorage = (path, data) =>
  set(generateLocalStorageKey(path), data)

export const generateLocalStorageKey = path => `${LS_KEYS.PAGE_CACHE}${path}`

export const populatePageCache = path => {
  if (isBuilderContext()) return
  if (getCachedPage(path)) return

  fetchPageData(path).catch(() => {}) // Fail silently
}

export const getCachedPage = path => {
  const localStorageCache = get(generateLocalStorageKey(path))

  return localStorageCache
    ? localStorageCache
    : window[INITIAL_STATE_VARIABLE] && window[INITIAL_STATE_VARIABLE][path]
    ? window[INITIAL_STATE_VARIABLE][path]
    : null
}
